import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { DemoRequestForm } from "@/components/landing/DemoRequestForm";

export const DemoRequestDialog = ({ open, onOpenChange, interest }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="login-dark max-w-2xl !bg-[#0F172A] !border-slate-800 text-white max-h-[92vh] overflow-y-auto" data-testid="demo-dialog">
      <DialogHeader>
        <DialogTitle style={{ fontFamily: "Plus Jakarta Sans, sans-serif" }}>Richiedi una dimostrazione</DialogTitle>
        <DialogDescription className="text-slate-400">Una demo guidata sui tuoi casi d'uso: WhatsApp Business, SMS, CRM e gestione di più aziende. Nessun impegno.</DialogDescription>
      </DialogHeader>
      <DemoRequestForm defaultInterest={interest} />
    </DialogContent>
  </Dialog>
);
